import React from "react";
import { routes } from "../../../../constants/routes";
import { Box, Typography } from "@mui/material";
import {
  AlertComponent,
  BreadcrumbComponent,
} from "../../../../common/components";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "./crm-paid-plans.scss";
import { AntSwitch } from "../../../user-management/user-management-list/components/ant-switch";
import ViewPlanDetails from "./view-plan-details";
import { AlertMessage } from "../../tenant-details/tenant-details-types";
import { getSubscriptionPlans } from "../../../../api/tenets";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { getPaidPlans, validationSchema } from "../crm-plans-utils";
import { Form, Formik } from "formik";
import { toggleCRMPlanStatus } from "../../../../api/crm-plans";

const breadcrumbLink = [
  {
    label: "CRM Plans",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "Paid Plans",
    link: routes.CREATE_CRM_PLAN,
    handleClick: () => {},
  },
];

const labelSwitch = { inputProps: { "aria-label": "Switch demo" } };

const CRMPaidPlans = () => {
  const [indexValue, setIndexValue] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [tabs, setTabs] = React.useState<any>([]);
  const [plans, setPlans] = React.useState<any>([]);
  const [alertMessage, setAlertMessage] = React.useState<AlertMessage>({
    open: false,
  });

  const getSubscriptionValues = async () => {
    try {
      setIsLoading(true);
      const response = await getSubscriptionPlans({planCategory: 'paid'});
      const resPlans = response?.data?.data || [];

      const { plans, tabs } = getPaidPlans(resPlans);
      setTabs(tabs);
      setPlans(plans);
      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
      console.error(e);
    }
  };

  React.useEffect(() => {
    getSubscriptionValues();
  }, []);

  const handleActiveToggle = async (planId: any, payload: any) => {
    try {
      setIsLoading(true);
      const res = await toggleCRMPlanStatus(planId, payload);
      const updatedPlans = plans.map((plan: any, idx: number) =>
        idx === indexValue ? { ...plan, active: payload.status } : plan
      );
      setPlans(updatedPlans);
      setAlertMessage({
        open: true,
        message:
          res?.data?.data?.message || "Active status updated successfully.",
        type: "success",
      });

      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);

      setAlertMessage({
        open: true,
        message:
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Some thing went wrong!",
        type: "error",
      });
    }
  };

  const showLoading = React.useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);

  const titles: any = {
    0: "Basic",
    1: "Starter",
    2: "Professional",
    3: "Enterprise",
  };

  return (
    <Box className="crm-paid-plans-wrapper">
      <Box>
        <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
      </Box>
      <Box className="crm-paid-plans-content-wrapper">
        <Formik
          initialValues={plans[indexValue] || {}}
          validationSchema={validationSchema}
          enableReinitialize
          validateOnBlur
          onSubmit={(values) => {
            // addTenet(temp, values);
          }}
        >
          {({ resetForm }) => (
            <Form>
              <Box className="tab-edit">
                <Box className="tab-section">
                  <Tabs
                    value={indexValue}
                    onChange={(
                      event: React.SyntheticEvent,
                      newValue: number
                    ) => {
                      setIndexValue(newValue);
                      resetForm({ values: plans[newValue] });
                    }}
                    allowScrollButtonsMobile
                    scrollButtons
                    variant="scrollable"
                    sx={{
                      "& .MuiTabs-scrollButtons": {
                        width: 32, // or your preferred size
                      },
                    }}
                  >
                    {tabs?.map((tab: any, index: number) => (
                      <Tab
                        key={index}
                        label={
                          <Box className="tab-label">
                            <Typography className="tab-label-text">
                              {tab}
                            </Typography>
                          </Box>
                        }
                      />
                    ))}
                  </Tabs>
                </Box>
              </Box>
              <Box>
                <Box className="paid-plans-switch">
                  <AntSwitch
                    {...labelSwitch}
                    checked={plans?.[indexValue]?.active || false}
                    onChange={(e) => {
                      const activePlan = plans[indexValue];
                      handleActiveToggle(activePlan?.id, {
                        status: !activePlan?.active,
                      });
                    }}
                  />
                  <Typography className="paid-plans-status">Active</Typography>
                </Box>
              </Box>

              <ViewPlanDetails
                activeTab={indexValue}
                title={titles[indexValue as keyof typeof titles]}
                plans={plans[indexValue]}
                setPlans={setPlans}
                allPlans={plans}
              />
            </Form>
          )}
        </Formik>
      </Box>
      {alertMessage?.open && (
        <AlertComponent
          message={alertMessage?.message}
          type={alertMessage?.type || "error"}
          open={alertMessage?.open}
          onClose={() => {
            setAlertMessage({ open: false });
          }}
        />
      )}
    </Box>
  );
};

export default CRMPaidPlans;
